class ContentTab {
	stateClasses = {
		active: 'content-tab__nav-item--active',
	};

	$activeTab = null;

	constructor($el) {
		this.$el = $el;
		this.$radios = $el.find('[data-contenttab="radio"]');
		this.$navItems = $el.find('[data-contenttab="nav-item"]');

		this.init();
	}

	init = () => {
		this.$radios.on('change', this.radioChangeHandler);
	};

	radioChangeHandler = e => {
		const activeTabId = $(e.target).attr('id');

		this.$navItems.removeClass(this.stateClasses.active);

		this.$activeTab = this.$navItems.filter((i, item) => {
			if (activeTabId == $(item).attr('for')) {
				return true;
			}
		});

		this.$activeTab.addClass(this.stateClasses.active);
	};
}

export default ContentTab;
